/** @format */
import parse from 'html-react-parser';
import moment from 'jalali-moment';

import { error as errorToast } from '../Components/Toast';
import useApi from '../hooks/api/Index';

export const getStep = async (stepName) => {
  let step = undefined;
  await useApi.get(
    `/general/step/${stepName}`,
    {},
    (res) => {
      let data = res.data.data;
      step = data;
    },
    (err) => {
      console.log(err);
    },
  );
  return step;
};

export const getSteps = async () => {
  let step = [];
  await useApi.get(
    `/general/step`,
    {},
    (res) => {
      let data = res.data.data;
      data.forEach((el) => {
        step.push(el.step_name);
      });
    },
    (err) => {
      console.log(err);
    },
  );
  return step;
};
export const showFirstRequestError = (errors) => {
  Object.values(errors).forEach((err) => {
    errorToast(err[0]);
  });
};

export const htmlToJsx = (html) => {
  return parse(html ?? '');
};

export const number_format = (Number) => {
  Number += '';
  Number = Number.replace(',', '');
  Number = Number.replace(',', '');
  Number = Number.replace(',', '');
  Number = Number.replace(',', '');
  Number = Number.replace(',', '');
  Number = Number.replace(',', '');
  let x = Number.split('.');
  let y = x[0];
  let z = x.length > 1 ? '.' + x[1] : '';
  let rgx = /(\d+)(\d{3})/;
  while (rgx.test(y)) y = y.replace(rgx, `$1,$2`);
  return y + z;
};

export const baseApiUrl = () =>
  process.env.REACT_APP_API_URL || 'https://eventsapi.isfaf.ir/api/v1';

/** Laravel origin (without /api/v1) — static files, roles PDF, legacy web routes */
export const siteBaseUrl = () => {
  if (process.env.REACT_APP_SITE_URL) {
    return process.env.REACT_APP_SITE_URL.replace(/\/$/, '');
  }
  return baseApiUrl().replace(/\/api\/v1\/?$/, '');
};

/** تبدیل مسیر ذخیره‌شده در DB به URL قابل نمایش در img */
export const resolveMediaUrl = (src) => {
  if (src == null || src === '') return null;
  const s = String(src).trim();
  if (!s) return null;
  if (/^https?:\/\//i.test(s)) return s;
  const base = siteBaseUrl();
  if (s.startsWith('/storage/')) return `${base}${s}`;
  if (s.startsWith('storage/')) return `${base}/${s}`;
  if (s.startsWith('/')) return `${base}${s}`;
  return `${base}/storage/${s.replace(/^\/+/, '')}`;
};

export const isStoredMediaPath = (src) => {
  if (!src || typeof src !== 'string') return false;
  const s = src.trim();
  if (!s) return false;
  if (/^https?:\/\//i.test(s)) return true;
  if (s.includes('/storage/') || s.startsWith('storage/')) return true;
  if (/\.(jpe?g|png|gif|webp|bmp|pdf)$/i.test(s)) return true;
  if (/^(users|team|events|files|public-files|id-card|file-signature)\//i.test(s)) return true;
  return false;
};

/** نمایش امن سمت — اگر API آبجekt برگرداند (باگ قدیمی) کرش نمی‌کند */
export const formatSidLabel = (item) => {
  const name = item?.sid_name;
  if (typeof name === 'string' && name.trim() !== '') {
    return name;
  }
  if (typeof name === 'number') {
    return String(name);
  }
  if (name && typeof name === 'object') {
    return '-';
  }
  const sid = item?.sid;
  if (sid === null || sid === undefined || sid === '') {
    return '-';
  }
  if (typeof sid === 'object') {
    return '-';
  }
  return String(sid);
};

export const frontBaseUrl = () =>
  (process.env.REACT_APP_FRONT_URL || 'https://events.isfaf.ir').replace(
    /\/$/,
    '',
  );

/**
 * Printable registration result (served by Laravel under /api/v1, not the React SPA).
 * @param {'user'|'team'} type
 */
export const registerPrintUrl = (eventId, trackingId, type = 'user') => {
  if (!eventId || trackingId == null || trackingId === '') {
    return '#';
  }
  const tracking = encodeURIComponent(String(trackingId).replace(/\//g, '_'));
  return `${baseApiUrl().replace(/\/$/, '')}/event/${eventId}/register-print/${type}/${tracking}`;
};
const parseDateParts = (value) => {
  const raw = String(value).trim().split(' ')[0].replace(/-/g, '/');
  const parts = raw.split('/').map((p) => parseInt(p, 10));
  if (parts.length < 3 || parts.some((n) => Number.isNaN(n))) {
    return null;
  }
  return { year: parts[0], month: parts[1], day: parts[2] };
};

/** سال میلادی (>1500) در رشته تاریخ */
export const isGregorianDateString = (value) => {
  const parts = parseDateParts(value);
  return parts ? parts.year > 1500 : false;
};

/** مقدار ورودی datepicker — همیشه شمسی YYYY/MM/DD */
export const toJalaliPickerValue = (value) => {
  if (value == null || value === '') {
    return '';
  }

  const str = String(value).trim();

  if (isGregorianDateString(str)) {
    const parts = parseDateParts(str);
    const m = moment(
      `${parts.year}/${parts.month}/${parts.day}`,
      'YYYY/M/D',
    );
    if (m.isValid()) {
      return m.locale('fa').format('YYYY/MM/DD');
    }
  }

  const parts = parseDateParts(str);
  if (!parts) {
    return str;
  }

  return `${parts.year}/${String(parts.month).padStart(2, '0')}/${String(parts.day).padStart(2, '0')}`;
};

/** تبدیل تاریخ فرم (شمسی) به میلادی برای API */
export const jalaliDateToGregorianApi = (value) => {
  if (value == null || value === '') {
    return null;
  }

  const str = String(value).trim();

  if (isGregorianDateString(str)) {
    const parts = parseDateParts(str);
    const m = moment(
      `${parts.year}/${parts.month}/${parts.day}`,
      'YYYY/M/D',
    );
    return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : null;
  }

  const converted = moment.from(str, 'fa', 'YYYY/MM/DD').locale('en');
  if (converted.isValid()) {
    return converted.format('YYYY-MM-DD HH:mm:ss');
  }

  const fallback = moment.from(str, 'fa', 'jYYYY/jMM/jDD').locale('en');
  return fallback.isValid() ? fallback.format('YYYY-MM-DD HH:mm:ss') : null;
};

export const numToEn = (number) => {
  return number
    .replace(/[\u0660-\u0669]/g, function (c) {
      return c.charCodeAt(0) - 0x0660;
    })
    .replace(/[\u06f0-\u06f9]/g, function (c) {
      return c.charCodeAt(0) - 0x06f0;
    });
};

export const isValidIranianNationalCode = (input) => {
  if (/^([0-9]+)_r/.test(input)) return true;

  if (!/^\d{10}$/.test(input)) return false;
  const check = +input[9];
  const sum =
    input
      .split('')
      .slice(0, 9)
      .reduce((acc, x, i) => acc + +x * (10 - i), 0) % 11;
  return sum < 2 ? check === sum : check + sum === 11;
};

export const isValidForeignersCode = (value) => {
  let input = value.replace('FGN-', '');
  if (
    input.length !== 8 &&
    input.length !== 11 &&
    (input.length < 8 ||
      input.length > 8 ||
      input.length < 11 ||
      input.length > 11)
  ) {
    return false;
  }

  return true;
};
export const countOfRecourd = (index, perpage, currentPage) => {
  return perpage * currentPage - perpage + index + 1;
};
export const serverErrorHandler = (errors, setServerErrors) => {
  let allErrors = {};
  Object.entries(errors).forEach((el) => {
    allErrors[[el[0]]] = el[1][0];
  });
  setServerErrors(allErrors);
};

/** HTTP status from useApi reject payload (axios response or legacy data-only). */
export const getApiErrorStatus = (err) => {
  if (err == null) return 0;
  const status = err.status ?? err.statusCode;
  if (status != null && status !== '') {
    return Number(status);
  }
  if (err.data?.status != null) {
    return Number(err.data.status);
  }
  return 0;
};

/** First user-facing message from API error body. */
export const getApiErrorMessage = (err, fallback = '') => {
  const data = err?.data ?? err;
  if (typeof data?.error === 'string' && data.error.trim()) {
    if (data.error === 'Unauthorized') {
      return 'کد ملی و یا کلمه عبور اشتباه است';
    }
    return data.error;
  }
  if (data?.errors && typeof data.errors === 'object') {
    const first = Object.values(data.errors).flat().find(Boolean);
    if (first) return first;
  }
  if (typeof data?.message === 'string' && data.message.trim()) {
    if (data.message === 'The given data was invalid.') {
      return fallback;
    }
    return data.message;
  }
  return fallback;
};

export const isEndedEvent = (event) => {
  console.log('raw end_register_date:', event.end_register_date);

  const now = moment();
  const end = moment(event.end_register_date) // خودکار پارس می‌کند
    .endOf('day');

  // console.log('now:', now.format('YYYY-MM-DD HH:mm:ss'));
  // console.log('end:', end.format('YYYY-MM-DD HH:mm:ss'));
  // console.log('end valid?', end.isValid());

  return now.isAfter(end);
};

export const getGatewayTypes = [
  {
    value: 1,
    label: 'به پرداخت ملت',
  },
  {
    value: 2,
    label: 'سداد',
  },
  {
    value: 3,
    label: 'بیت پی',
  },
  {
    value: 4,
    label: 'سپ',
  },
];

export const getCurrencyCodes = [
  {
    value: 'Toman',
    label: 'تومان',
  },
  {
    value: 'Rial',
    label: 'ریال',
  },
];
/** 1 = مرد، 2 = زن (در پروفایل قدیمی 0 هم زن است) */
export const normalizeParticipantGender = (gender) => {
  if (gender === null || gender === undefined || gender === '') {
    return null;
  }
  const g = Number(gender);
  if (g === 1) return 1;
  if (g === 0 || g === 2) return 2;
  return g;
};

/** رویداد: 1 = آقایان، 2 = بانوان، 3 = هردو */
export const isParticipantGenderAllowedForEvent = (eventGender, participantGender) => {
  const eventG = Number(eventGender);
  const userG = normalizeParticipantGender(participantGender);
  if (eventG === 3 || userG === null) {
    return true;
  }
  return eventG === userG;
};

export const eventGenderLabel = (eventGender) => {
  const g = Number(eventGender);
  if (g === 1) return 'آقایان';
  if (g === 2) return 'بانوان';
  return 'آقایان و بانوان';
};

/** registered_by=Board → ادمین، هیئت استان (Provinces)، نقش‌های Board* */
export const canManageBoardRegistration = ({ can, canBoard }) =>
  can('Super Admin') ||
  can('Dyaco Admin') ||
  can('Admin') ||
  can('Provinces') ||
  canBoard();

export const canSelfRegisterOnEvent = (event, roleCheck) => {
  if (!event || event.registered_by !== 'Board') {
    return true;
  }

  return canManageBoardRegistration(roleCheck);
};

export const getRegistredBy = [
  {
    value: 'All',
    label: 'همه',
  },
  {
    value: 'Board',
    label: 'هیئت ها',
  },
  // {
  //   value: 'User',
  //   label: 'کاربران',
  // },
  // {
  //   value: 'Super Admin',
  //   label: 'ادمین',
  // },
];
